export const date_fields = [
  {
    title:'时间升序',
    value: 'asc'
  },
  {
    title:'时间降序',
    value: 'desc'
  }
]

export const BX_CATEGORY_LIST = [
  {
    name: '市内交通、快递费、办公软件相关、办公用品',
    id: '1',
  },
  {
    name: '团建费用（餐饮、交通）',
    id: '2',
  },
  {
    name: '外部购买图书和课程',
    id: '3',
  },
  {
    name: '内部购买课程、周边',
    id: '4',
  },
  {
    name: '跨组约咖啡',
    id: '5',
  },
  {
    name: '组内约咖啡',
    id: '6',
  },
  {
    name: '出差学习（住宿、交通、餐饮等）',
    id: '7',
  },
  {
    name: '出差工作（住宿、交通、餐饮等）',
    id: '8',
  },
  {
    name: '开会物料、餐饮、零食等',
    id: '9',
  },
  {
    name: '用户运营红包、礼物',
    id: '10',
  },
  {
    name: '加班餐、工作餐',
    id: '11',
  },
  {
    name: '产品研发（如购买教具等）',
    id: '12',
  },
  {
    name: '其他（需在‘报销备注’记录）',
    id: '99',
  },
];
// 通过合同管理 => 账单生成 挑选出能够使用的字段
export const generate_from_bill = ['apply_user', 'apply_user_id', 'fill_user', 'fill_user_id', 'created_at', 'team_id', 'contract_id', 'company_id']
export const BX_CATEGORY_HASH = Object.assign(...BX_CATEGORY_LIST.map(obj => ({ [obj.id]: obj.name })));

export const register_hash = {
  seller: '销售方',
  buyer: '购买方',
  tax_rate: '税率',
  invoice_type: '发票类型'
}